import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Tabs,
  Tab,
  Toolbar
} from '@mui/material';
import { Twitter as TwitterIcon, LinkedIn as LinkedInIcon } from '@mui/icons-material';
import PostHistory from '../Components/post-history/PostHistory';
import LinkedInPostHistory from '../Components/post-history/LinkedInPostHistory';
import Sidebar from '../Components/sideBar/sideBar';
import Header from '../Components/header/Header';
import { useNavigate } from 'react-router';
// Custom TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`post-history-tabpanel-${index}`}
      aria-labelledby={`post-history-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

// Accessibility props for tabs
function a11yProps(index) {
  return {
    id: `post-history-tab-${index}`,
    'aria-controls': `post-history-tabpanel-${index}`,
  };
}

const PostHistoryPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const [routeLoading, setRouteLoading] = useState(false);
   const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
const drawerWidth = 260;
  return (
     <Box sx={{ display: "flex" }}>
      <Sidebar
    drawerWidth={drawerWidth}
    onNavigate={(path) => {
      setRouteLoading(true);
      navigate(path);
      setTimeout(() => setRouteLoading(false), 800);
    }}
  />

      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: "#f9f9f9", minHeight: "100vh" }}
      >
        <Header />

        <Toolbar />
    <Box sx={{ p: 3 } }>
      {/* Page Header */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          mb: 4,
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
               fontWeight: 600,
                      mb: 0.5,
                      color: "#4896a1"
            }}
          >
            Post History
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{fontSize:'0.9rem'}}  >
            View and manage your social media post history
          </Typography>
        </Box>
      </Box>

      {/* Tabs */}
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          mb: 3,
          borderRadius: 3,
          overflow: 'hidden'
        }}
      >
        <Tabs
  value={tabValue}
  onChange={handleTabChange}
  aria-label="post history tabs"
  sx={{
    borderBottom: 1,
    borderColor: "divider",
    "& .MuiTabs-indicator": {
      display: "none", // remove underline
    },
    "& .MuiTab-root": {
      minHeight: 60,
      textTransform: "none",
      fontSize: "1rem",
      fontWeight: 500,
 
      // 👇 Kill browser focus ring
      "&:focus": {
        outline: "none !important",
      },
      "&.Mui-focusVisible": {
        outline: "none !important",
      },
    },
  }}
>
          <Tab
            icon={<TwitterIcon sx={{ color: '#1DA1F2' }} />}
            label="Twitter"
            iconPosition="start"
            sx={{
              '&.Mui-selected': {
                color: '#1DA1F2',
              },
            }}
            {...a11yProps(0)}
          />
          <Tab
            icon={<LinkedInIcon sx={{ color: '#0077B5' }} />}
            label="LinkedIn"
            iconPosition="start"
            sx={{
              '&.Mui-selected': {
                color: '#0077B5',
              },
            }}
            {...a11yProps(1)}
          />
        </Tabs>
      </Paper>

      {/* Main Content */}
      <Grid container spacing={3} sx={{ display: 'flex', flexDirection: 'column' }} >
        <Grid item xs={12}>
          <TabPanel value={tabValue} index={0}>
            <PostHistory />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <LinkedInPostHistory />
          </TabPanel>
        </Grid>

      

      </Grid>
    </Box>
    </Box>
    </Box>
  );
};

export default PostHistoryPage;